import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { editAssetsCommonValues } from '@api/assets';

import { TAssetsCommonValuesDTO } from '@interfaces/assets/dto/assetsDTO';

import { ESnackbarTypes } from '@enums/common';

import {
	ASSET,
	ASSETS_CHANGE_COMMON_VALUES,
	ASSETS_LIST,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateSetAssetsCommonValues = ({ onClose }: { onClose: () => void }) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: saveAssetsCommonValues,
		isLoading: isLoadingSaveAssetsCommonValues,
	} = useMutation<TAssetsCommonValuesDTO>({
		mutationKey: [ASSETS_CHANGE_COMMON_VALUES],
		mutationFn: editAssetsCommonValues,
		onSuccess: () => {
			onClose();

			dispatch(setSnackbar({
				message: responseMessages.commonValues,
				type: ESnackbarTypes.success,
			}));

			return [
				queryClient.invalidateQueries([ASSETS_LIST]),
				queryClient.invalidateQueries([ASSET]),
			];
		},
	});

	return {
		saveAssetsCommonValues,
		isLoadingSaveAssetsCommonValues,
	};
};
